// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2nNEQ","upload":"Small_upload__doi_u","imageWrap":"Small_imageWrap__3eB3S","removeBtn":"Small_removeBtn__mF9Ei"};